exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.order-list[data-v-b3ed36e4] {\n  max-height: 400px;\n}\n.order-list__row[data-v-b3ed36e4] {\n  cursor: pointer;\n}\n.orders__list[data-v-b3ed36e4] {\n  width: 100%;\n}\n@media only screen and (max-width: 985px) {\n.order-list__title[data-v-b3ed36e4] {\n    min-height: 24px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b3ed36e4","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/trade/index/components/orders/Orders.List.vue
// module id = q6Gy
// module chunks = 1